import { actions as mainActions } from "../../Root/actions";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actions as rootActions } from "../actions";
import { NAME as ROOT_NAME } from "../../Root/reducer";
import { isSaving } from "../../Root/saving";
import { NAME as COMPANIES_NAME } from "../reducer";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InfoTable from "../../../components/InfoTable";
import NotificationInfo from "../components/NotificationInfo";
import EditNotification from "../components/EditNotifications";
import CreateNotificationMemo from "../components/CreateNotificationMemo";
import NotificationMemoList from "../components/NotificationMemoList";
import CreateProduct from "../../Product/container/CreateProduct";
import ListProduct from "../../Product/container/ListProduct";
import { Link, withRouter } from "react-router-dom";
import LoadError from "../../../components/LoadError";
import ConfirmDeleteButton from "../../../components/ConfirmDeleteButton";
import { lookupOf } from "../lookup";

// Helper function to extract URL parameters
function extractUrlValue(key, url) {
  if (typeof url === "undefined") url = window.location.href;
  const match = url.match("[?&]" + key + "=([^&]+)");
  return match ? match[1] : null;
}

function mapStateToProps(state) {
  return {
    ...state[COMPANIES_NAME],
    // Идёт ли сохранение заметки и напоминания: их кнопки блокируются на это время.
    memoSaving: isSaving(state[ROOT_NAME], "NORIFICATION_MEMO_CREATE"),
    reminderSaving: isSaving(state[ROOT_NAME], "NOTIFICATION_CREATE_OR_UPDATE"),
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...rootActions,
      redirectTo: mainActions.redirectTo,
      sendMessageTelegram: mainActions.sendMessageTelegram,
    },
    dispatch
  );

class CompanyPage extends React.Component {
  constructor(props) {
    super(props);
    const urlId = extractUrlValue("id");

    this.state = {
      selectedCompanyId: urlId, // Use URL parameter if available
      hideDetails: true,
      fetchStatus: "pending", // Track fetching status
    };
  }

  componentDidMount() {
    this.props.resetCompanyForms();
    this.fetchCompanyData();

    // Set up listener for history changes
    this.unlisten = this.props.history.listen((location) => {
      const urlId = extractUrlValue("id", location.search);
      if (this.state.selectedCompanyId !== urlId) {
        this.props.resetCompanyForms();
        this.setState(
          { selectedCompanyId: urlId, fetchStatus: "pending" },
          () => {
            this.fetchCompanyData();
          }
        );
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const urlId = extractUrlValue("id");

    // Avoid fetching if fetchStatus is 'success' or 'error'
    if (
      this.state.fetchStatus === "pending" &&
      this.state.selectedCompanyId !== urlId
    ) {
      this.setState({ selectedCompanyId: urlId }, () => {
        this.fetchCompanyData();
      });
    }
  }

  componentWillUnmount() {
    this.props.resetCompanyForms();
    this.setState({
      hideDetails: true,
    });
    // Clean up listener
    if (this.unlisten) {
      this.unlisten();
    }
  }

  // fetchStatus: "pending" (ищем), "success" (нашли) или "notfound" (такой компании нет или её
  // удалили). Сбой запроса сюда не попадает: его показывает LoadError (companyError в store).
  fetchCompanyData = async () => {
    const companyId = this.state.selectedCompanyId;

    // В адресе нет id: показывать нечего, искать не у кого.
    if (!companyId) {
      this.setState({ fetchStatus: "notfound" });
      return;
    }

    this.setState({ fetchStatus: "pending" });
    const companyResponse = await this.props.getCompany(companyId);

    // Пока шёл запрос, человек мог открыть другую компанию: ответ про эту уже не нужен.
    if (this.state.selectedCompanyId !== companyId) return;
    const lookup = lookupOf(companyResponse);
    if (lookup === "failed") return;
    if (lookup === "notfound") {
      this.setState({ hideDetails: true, fetchStatus: "notfound" });
      return;
    }

    this.setState({ fetchStatus: "success" });
    this.props.getNotification({ companyId });
    this.props.getNotificationMemo({ companyId });
  };

  toggleDetails = () => {
    this.setState((prevState) => ({
      hideDetails: !prevState.hideDetails,
    }));
  };

  render() {
    const { selectedCompany } = this.props;

    if (this.props.companyError) {
      return <LoadError onRetry={this.fetchCompanyData} />;
    }

    if (this.state.fetchStatus === "notfound") {
      return (
        <Paper style={{ padding: "32px 24px", textAlign: "center" }}>
          <Typography variant="h6">Не найдено</Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
            Такой компании нет: возможно, её удалили.
          </Typography>
          <Button variant="contained" color="primary" disableElevation component={Link} to="/companylist">
            К списку компаний
          </Button>
        </Paper>
      );
    }

    if (!selectedCompany || !selectedCompany.id) {
      return <div>Поиск информации о компании...</div>;
    }

    return (
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Grid component={Paper} container spacing={3}>
            <InfoTable
              data={[
                {
                  data: ["Название:", this.props.selectedCompany.name],
                  hiden: false,
                },
                {
                  data: [
                    "Общая площадь:",
                    this.props.selectedCompany.generalArea,
                  ],
                  hiden: false,
                  options: { units: " Га" },
                },
                {
                  data: ["Имя директора:", this.props.selectedCompany.director],
                  hiden: false,
                },
                {
                  data: [
                    "Телефон директора:",
                    this.props.selectedCompany.phoneNumber,
                  ],
                  hiden: false,
                },
                {
                  data: ["Тип компании:", this.props.selectedCompany.type],
                  hiden: false,
                },
                {
                  data: ["Область:", this.props.selectedCompany.state],
                  hiden: this.state.hideDetails,
                },
                {
                  data: ["Район:", this.props.selectedCompany.region],
                  hiden: this.state.hideDetails,
                },
                {
                  data: ["Населённый пункт:", this.props.selectedCompany.city],
                  hiden: this.state.hideDetails,
                },
              ]}
            />
            <Grid item xs={8}>
              <FormControl fullWidth>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={this.toggleDetails}
                >
                  {this.state.hideDetails ? "Показать детали" : "Убрать детали"}
                </Button>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl fullWidth>
                <Button
                  variant="outlined"
                  component={Link}
                  color="primary"
                  to={{
                    pathname: "/editcompany",
                    search: `?id=${selectedCompany.id}`,
                    state: { fromCompany: true },
                  }}
                >
                  Редактировать
                </Button>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl fullWidth>
                <ConfirmDeleteButton
                  label="Удалить"
                  title="Удалить компанию?"
                  text={`Компания «${selectedCompany.name}» будет удалена безвозвратно вместе со своими культурами, напоминанием и заметками, а также убрана из списков рассылки.`}
                  confirmLabel="Удалить компанию"
                  onConfirm={() => {
                    // На список перейдёт само действие, когда сервер подтвердит удаление.
                    this.props.deleteCompany(selectedCompany.id);
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <br />
        <Grid item xs={12}>
          {this.props.showEditNotification ? (
            <EditNotification
              notification={this.props.notification}
              editAction={this.props.editNotification}
              companyId={selectedCompany.id || this.state.selectedCompanyId}
              updateAction={this.props.createOrUpdateNotification}
              saving={this.props.reminderSaving}
              refereshAction={() => {
                this.props.getNotificationMemo({
                  companyId: selectedCompany.id || this.state.selectedCompanyId,
                });
              }}
            />
          ) : (
            <NotificationInfo
              notification={this.props.notification}
              isProcesed={this.props.notification.isProcesed}
              editAction={this.props.editNotification}
              marckAction={this.props.createOrUpdateNotification}
              refereshAction={() => {
                this.props.getNotificationMemo({
                  companyId: selectedCompany.id || this.state.selectedCompanyId,
                });
              }}
            />
          )}
        </Grid>
        <br />
        <br />
        <Grid item md={6} xs={12}>
          {this.props.showCreateMemo ? (
            <CreateNotificationMemo
              editAction={this.props.createMemoAction}
              createNotificationMemo={this.props.createNotificationMemo}
              saving={this.props.memoSaving}
              companyId={selectedCompany.id || this.state.selectedCompanyId}
              refereshAction={() => {
                this.props.getNotificationMemo({
                  companyId: selectedCompany.id || this.state.selectedCompanyId,
                });
              }}
            />
          ) : (
            <NotificationMemoList
              editAction={this.props.createMemoAction}
              tableColumns={this.props.notificationMemoColumns}
              tableData={this.props.notificationMemo}
              companyId={selectedCompany.id || this.state.selectedCompanyId}
            />
          )}
        </Grid>
        <br />
        <br />
        <Grid item md={6} xs={12}>
          {this.props.showCreateProduct ? (
            <CreateProduct
              editAction={this.props.createProductAction}
              companyId={selectedCompany.id || this.state.selectedCompanyId}
            />
          ) : (
            <ListProduct
              editAction={this.props.createProductAction}
              companyId={selectedCompany.id || this.state.selectedCompanyId}
              companyType={selectedCompany.type}
            />
          )}
        </Grid>
      </Grid>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CompanyPage)
);
